export enum Level {
  Off = 0,
  Error = 10,
  Warning = 20,
  Info = 30,
  Debug = 40,
  Trace = 50,
  Verbose = 100,
}

const preferDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

export default class Logger {

  public static LEVEL_OFF = Level.Off;
  public static LEVEL_ERROR = Level.Error;
  public static LEVEL_WARNING = Level.Warning;
  public static LEVEL_INFO = Level.Info;
  public static LEVEL_DEBUG = Level.Debug;
  public static LEVEL_TRACE = Level.Trace;
  public static LEVEL_VERBOSE = Level.Verbose;

  private static filterLevel = Level.Verbose;
  private static isColorEnabled = true;
  private static colorTheme = 'auto';

  public static disableColor() {
    this.isColorEnabled = false;
  }

  public static enableColor() {
    this.isColorEnabled = true;
  }

  public static filter(level: Level) {
    this.filterLevel = level;
  }

  public static theme(name: 'auto' | 'light' | 'dark') {
    this.colorTheme = name;
  }

  public static log(...message: any) {
    if (Level.Verbose <= Logger.filterLevel) {
      console.log('%c[LOG]:', 'font-weight: bold', ...message);
    }
  }

  public static info(...message: any) {
    if (Level.Info <= Logger.filterLevel) {
      console.log(
        '%c[INFO]:',
        this.colorize(Level.Info),
        ...message
      );
    }
  }

  public static error(...message: any) {
    if (Level.Error <= Logger.filterLevel) {
      console.log(
        '%c[ERROR]:',
        this.colorize(Level.Error),
        ...message
      );
    }
  }

  public static warning(...message: any) {
    if (Level.Warning <= Logger.filterLevel) {
      console.log(
        '%c[WARNING]:',
        this.colorize(Level.Warning),
        ...message
      );
    }
  }

  public static debug(...message: any) {
    if (Level.Debug <= Logger.filterLevel) {
      console.log('[DEBUG]:', ...message);
    }
  }

  public static trace(...message: any) {
    if (Level.Trace <= Logger.filterLevel) {
      console.log('[TRACE]:', ...message);
    }
  }

  private static colorize(mode = Level.Verbose) {
    if (!this.isColorEnabled) {
      return;
    }
    let isDark = false;
    if (this.colorTheme === 'auto') {
      isDark = preferDark;
    }
    else {
      isDark = this.colorTheme === 'dark';
    }
    switch (mode) {
      case Level.Info:
        return isDark ? this.style('#002640', '#3498db') : this.style('#E3F1FF', '#0984E3');
      case Level.Warning:
        return isDark ? this.style('#332B00', '#F7D698') : this.style('#FFFBE5', '#70541D');
      case Level.Error:
        return isDark ? this.style('#290000', '#FF8080') : this.style('#FFF0F0', '#FF2525');
      case Level.Verbose:
      case Level.Debug:
      case Level.Trace:
      default:
        return '';
    }

  }

  private static style(background: string, color: string) {
    return `background: ${background}; color: ${color};font-weight: bold`;
  }

}

export const log = Logger.log;
